import mutations from './eDoc.mutations'
import actions from './eDoc.actions'
import getters from './eDoc.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
